import { useTranslations } from './useTranslations';

/**
 * Composable for formatting dates according to locale
 */
export function useDateFormatter() {
    const { locale } = useTranslations();

    const formatDate = (dateString: string): string => {
        if (!dateString) return '';

        try {
            const date = new Date(dateString + 'T00:00:00');
            const options: Intl.DateTimeFormatOptions = {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            };

            return new Intl.DateTimeFormat(locale.value === 'en' ? 'en-US' : locale.value === 'fr' ? 'fr-FR' : 'es-ES', options).format(date);
        } catch {
            return dateString;
        }
    };

    const formatTime = (timeString: string): string => {
        if (!timeString) return '';

        try {
            const [hours, minutes] = timeString.split(':');
            const date = new Date();
            date.setHours(parseInt(hours), parseInt(minutes));

            const options: Intl.DateTimeFormatOptions = {
                hour: '2-digit',
                minute: '2-digit',
                hour12: locale.value === 'en',
            };

            return new Intl.DateTimeFormat(locale.value === 'en' ? 'en-US' : locale.value === 'fr' ? 'fr-FR' : 'es-ES', options).format(date);
        } catch {
            return timeString;
        }
    };

    const formatDateTime = (dateString: string, timeString: string): string => {
        return `${formatDate(dateString)} à ${formatTime(timeString)}`;
    };

    return {
        formatDate,
        formatTime,
        formatDateTime,
    };
}
